import fixScroll from './fixScroll';

export { fixScroll };



// WEBPACK FOOTER //
// ./src/components/helpers/index.js